<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 我的发票详情 -->
          <div class="ttshop_coupon min_h">
            <div class="ttshop_couponnav">
              <ul class="clearfloat">
                <li class="active">发票详情</li>
              </ul>
            </div>

            <!-- 发票详情列表 -->
            <div class="ttshop_invoicexq">
              <div class="ttshop_invoicexqlist">
                <h5>订单信息</h5>
                <ul>
                  <li class="clearfloat">
                    <span>订单状态</span>
                    <p>已支付</p>
                  </li>
                  <li class="clearfloat">
                    <span>订单编号</span>
                    <p>{{list.order_no}}</p>
                  </li>
                  <li class="clearfloat">
                    <span>下单时间</span>
                    <p>{{list.addtime}}</p>
                  </li>
                  <li class="clearfloat">
                    <span>发票类型</span>
                    <p>普通发票</p>
                  </li>
                </ul>
              </div>
              <div class="ttshop_invoicexqlist">
                <h5>发票信息</h5>
                <ul>
                  <li class="clearfloat">
                    <span>发票状态</span>
                    <p v-show="list.is_send == 1">已开票</p>
                    <p v-show="list.is_send == 0">未开票</p>
                  </li>
                  <li class="clearfloat">
                    <span>发票内容</span>
                    <p>商品明细</p>
                  </li>
                  <li class="clearfloat">
                    <span>抬头类型</span>
                    <p v-show="list.type == 1">个人</p>
                    <p v-show="list.type == 2">企业</p>
                  </li>
                  <li class="clearfloat">
                    <span>发票抬头</span>
                    <p>{{list.header}}</p>
                  </li>
                  <li class="clearfloat" v-show="list.type == 2">
                    <span>税号</span>
                    <p>{{list.taxpayer}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      id:this.$route.query.id,
      list:''
    };
  },
  mounted() {
    this.getinvoiceDetails()
  },
  methods: {
    //获取
    getinvoiceDetails() {
      this.$api
        .invoiceDetails({
          order_id: this.id,
        })
        .then((res) => {
          console.log(res.data);
          this.list = res.data
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;
  .ttshop_couponnav {
    width: 100%;
    margin-bottom: 20px;
    ul {
      li {
        float: left;
        cursor: pointer;
        padding-bottom: 10px;
        margin-right: 24px;
        box-sizing: border-box;
        position: relative;
        font-size: 12px;
        line-height: 12px;
        color: #333;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        &:last-child {
          margin-right: 0;
        }
        &::before {
          content: "";
          width: 00%;
          height: 2px;
          background: #ff0e25;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          -o-transform: translateX(-50%);
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
        }
        &:hover {
          color: #ff0e25;
        }
        &:hover::before {
          width: 100%;
        }
        &.active {
          color: #ff0e25;
        }
        &.active:before {
          width: 100%;
        }
      }
    }
  }
  .ttshop_invoicexq {
    width: 100%;
    .ttshop_invoicexqlist {
      width: 100%;
      margin-bottom: 20px;
      h5 {
        width: 100%;
        height: 32px;
        background: #f5f5f5;
        padding: 0 24px;
        box-sizing: border-box;
        font-size: 12px;
        color: #333;
        font-weight: 500;
        line-height: 32px;
      }
      ul {
        li {
          width: 100%;
          height: 40px;
          border: 1px solid #ebebeb;
          box-sizing: border-box;
          line-height: 40px;
          border-top: 0;
          &:first-child {
            border-top: 1px solid #ebebeb;
          }
          span {
            float: left;
            width: 160px;
            height: 40px;
            border-right: 1px solid #ebebeb;
            font-size: 12px;
            color: #666;
            font-weight: 400;
            padding-left: 24px;
            box-sizing: border-box;
          }
          p {
            float: left;
            width: 788px;
            padding: 0 24px;
            font-size: 12px;
            color: #666;
            font-weight: 400;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>
